import React from 'react';
import useLangTranslation from '../../../customHooks/languageProvider';
import AddNewParent from './AddNewParent';

const AddNewParentWrapper = () => {
    const { getLangTranslation } = useLangTranslation();

        return (
            <AddNewParent
                getLangTranslation={getLangTranslation}
            />
        )
}

export default AddNewParentWrapper